import { forwardRef } from "react";

import BaseCard from "../BaseCard";
import { ArticleCard, BundleCard, VideoCard } from "./builders";

import {
  ContentTypeEnum,
  CardViewmodelAndProps,
} from "./ContentCardV2.interface";

const BASE_CARD_CONTENT_TYPES: Set<ContentTypeEnum> = new Set([
  ContentTypeEnum.WORKSHEET,
  ContentTypeEnum.EXTERNAL_LINK,
  ContentTypeEnum.INTERNAL_LINK,
  ContentTypeEnum.PHET_SIMULATION,
  ContentTypeEnum.TUVA_DATASET,
]);

const ContentCardV2 = forwardRef<HTMLElement, CardViewmodelAndProps>(
  (props, ref) => {
    const contentType = props?.metadata?.content_type;

    if (contentType === ContentTypeEnum.ARTICLE) {
      return (
        <ArticleCard
          ref={ref}
          dataQaSelector="article-content-card"
          {...props}
        />
      );
    }

    if (contentType === ContentTypeEnum.BUNDLE) {
      return (
        <BundleCard ref={ref} dataQaSelector="bundle-content-card" {...props} />
      );
    }

    if (contentType === ContentTypeEnum.INTERACTIVE_VIDEO) {
      return (
        <VideoCard
          ref={ref}
          dataQaSelector="interactive-video-content-card"
          {...props}
        />
      );
    }

    if (contentType === ContentTypeEnum.GENERATION_GENIUS_VIDEO) {
      return (
        <VideoCard
          ref={ref}
          dataQaSelector="generation-genius-content-card"
          {...props}
        />
      );
    }

    if (BASE_CARD_CONTENT_TYPES.has(contentType)) {
      return (
        <BaseCard
          ref={ref}
          contentId={props?.id}
          contentTag="Resource"
          displayDate={props.display_date}
          images={props.images}
          url={props.url}
          title={props.title}
        />
      );
    }

    return null;
  },
);

export default ContentCardV2;
